export default __webpack_public_path__ + "static/media/drone4.a99205e5.jpg";